<template>
    <div class="content">
      <a href="#" @click.prevent class="screenReaderOnly">Top of content</a>
      <h1 :class="{ screenReaderOnly: skipIntro }">District Time Machine</h1>
      <!-- Hide intro paragraph after location search -->
      <div v-if="!skipIntro">
        <p>
          Congressional districts are redrawn based on new census data every 10 years, but these maps can be challenged and revised, following each state’s unique redistricting process and rules.
        </p>
        <p>Explore your district’s unique history.</p>
      </div>
      <div v-if="dataLoaded">
        <div class="annotation" :class="{ large: skipIntro }">
          <AnnotationSummary :isIntro="true"
                             :stateAnnotations="stateAnnotations"
                             :latestDistrictCode="latestDistrictCode"
                             :numDistricts="numDistricts"
                             :totalTimelineSpan="totalTimelineSpan" />
        </div>
        <div class="scroll">
          <div v-if="isMobile">
            <BigButton text="Show past districts" :action="hideIntro" />
          </div>
          <div v-else>
            <a href="#" class="scrollText" @click.prevent="hideIntro" alt="Jump to timeline">
              <img src="../assets/images/arrow.svg" alt="" />
              <div>Scroll down to go back in time</div>
            </a>
            <div v-if="visibleIntro" class="animatedArrow"></div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="loadError" class="errorText">No data available at that location. Please try again:</div>
        <div class="searchWrapper">
          <SearchBox :isMobile="isMobile" :updateLocation="updateLocation" :showLoading="showLoading" :showAutocompleteBelow="true" />
        </div>
      </div>
    </div>
</template>

<script>
  import BigButton from './BigButton';
  import SearchBox from './SearchBox';
  import AnnotationSummary from './AnnotationSummary';

  export default {
    name: 'ScrollAwayContent',
    components: {
      BigButton,
      SearchBox,
      AnnotationSummary
    },
    props: ['visibleIntro', 'dataLoaded', 'skipIntro', 'loadError',
            'isMobile', 'updateLocation', 'showLoading', 'hideIntro',
            'stateAnnotations', 'latestDistrictCode', 'numDistricts', 'totalTimelineSpan'],
    mounted() {
      // Put keyboard focus at top of content
      this.$el.querySelectorAll('a')[0].focus();
    }
  }
</script>

<style lang="scss" scoped>
@import '~styles/variables.scss';

.content {
  font-size: 1.125rem;
  box-sizing: border-box;
  padding: 35px 60px 30px;
  text-align: center;
}
h1 {
  @include font-family-compressed();
  font-size: $size-1;
  margin: 0;
}
.annotation {
  margin-top: 1.5em;
  &.large {
    font-size: 24px;
  }
}
.searchWrapper {
  max-width: 330px;
  margin: 1.25em auto 0;
}

.scrollText {
  color: white;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 12px;
  font-weight: $bold;
  letter-spacing: 0.5px;

  img {
    height: 20px;
    margin: 2em auto 0.5em auto;
  }
}


// Animated arrow
.animatedArrow {
  position: fixed;
  bottom: 50px;
  left: 50%;
  width: 18px;
  height: 18px;
  margin-left: -12px;
  border-left: 2px solid #000;
  border-bottom: 2px solid #000;
  opacity: 0;
  box-sizing: border-box;
  -webkit-animation:
    dropsubtle 1.5s ease-in-out 4s 7,
    dropbold 1.25s ease-in-out 14.5s infinite;
  animation:
    dropsubtle 1.5s ease-in-out 4s 7,
    dropbold 1.25s ease-in-out 14.5s infinite;
  animation-fill-mode: forwards;
}
@-webkit-keyframes dropsubtle {
  0% {
    -webkit-transform: rotate(-45deg) translate(0, 0);
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    -webkit-transform: rotate(-45deg) translate(-20px, 20px);
    opacity: 0;
  }
}
@keyframes dropsubtle {
  0% {
    transform: rotate(-45deg) translate(0, 0);
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    transform: rotate(-45deg) translate(-20px, 20px);
    opacity: 0;
  }
}
@-webkit-keyframes dropbold {
  0% {
    -webkit-transform: rotate(-45deg) translate(0, 0);
    opacity: 0;
    width: 24px;
    height: 24px;
  }
  50% {
    opacity: 1;
    width: 24px;
    height: 24px;
  }
  100% {
    -webkit-transform: rotate(-45deg) translate(-25px, 25px);
    opacity: 0;
    width: 24px;
    height: 24px;
  }
}
@keyframes dropbold {
  0% {
    transform: rotate(-45deg) translate(0, 0);
    opacity: 0;
    width: 24px;
    height: 24px;
  }
  50% {
    opacity: 1;
    width: 24px;
    height: 24px;
  }
  100% {
    transform: rotate(-45deg) translate(-25px, 25px);
    opacity: 0;
    width: 24px;
    height: 24px;
  }
}


.errorText {
  color: #ffaea0;
  font-weight: $bold;
  margin: 1.5em 0;
}
/* Mobile view (<900px wide) */
.mq-mobile {
  .content {
    padding: 1em;
  }
  h1 {
    margin: 0;
    font-size: 2rem;
  }
  p {
    font-size: 1rem;
  }
  .annotation {
    max-width: 600px;
    margin: 0 auto;
    &.large p {
      font-size: 1.375rem;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ScrollAwayContent.vue